import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../assest/css/Course.css";
import { FaStar, FaLaptop } from "react-icons/fa";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../Footer/Footer";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Alert,
} from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import courseImg from "../../assest/image/Courses/Why Choose Course.jpg";
import img from "../../assest/image/Courses/Why Choose Course.jpg";
import Course1 from "../../assest/image/Courseimage/Course/python-full-stack-development.png";
import Course2 from "../../assest/image/Courseimage/Course/java-full-stack-development.png";
import Course3 from "../../assest/image/Courseimage/Course/MERN-stack-development.png";
import Course4 from "../../assest/image/Courseimage/Course/MEAN-stack-development.png";
import Course5 from "../../assest/image/Courseimage/Course/Mobile-App-Development.png";
import Course6 from "../../assest/image/Courseimage/Course/Data-Analysis.png";
import Course7 from "../../assest/image/Courseimage/Course/UIUX-Designing.png";
import Course8 from "../../assest/image/Courseimage/Course/aws.png";
import Course9 from "../../assest/image/Courseimage/Course/DevOps Engineer.png";
import { FiArrowUpRight } from "react-icons/fi";
import axios from 'axios';
import Apiurl from '../environments/Apiurl';

const Courses = () => {
  const [meta, setMeta] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    interestedCourse: "",
    learningMode: "",
  });
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });

    const CoursesMeta = data[0]?.courses_page;
    if (CoursesMeta) {
      setMeta(CoursesMeta);
    }

    return () => {
      AOS.refresh();
    };
  }, []);

  const courses = [
    "Python Full Stack Development",
    "Java Full Stack Development",
    "MERN Stack Development",
    "MEAN Stack Development",
    "Mobile App Development",
    "Data Analysis",
    "UI/UX Designing",
    "AWS Cloud",
    "DevOps Engineer",
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Clear error for the field being edited
    setErrors({ ...errors, [name]: "" });
    if (submitError) setSubmitError('');
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim())
      newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email ID is required";
    } else if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      newErrors.email = "Valid email is required";
    }
    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone Number is required";
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone Number must be 10 digits";
    }
    if (!formData.interestedCourse)
      newErrors.interestedCourse = "Please select a course";
    if (!formData.learningMode)
      newErrors.learningMode = "Please select a learning mode";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSubmitError('');
      setSubmitMessage('');
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');
    setSubmitMessage('');

    // Map to backend format
    const payload = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone_number: formData.phoneNumber.trim(),
      interested_course: formData.interestedCourse,
      preferred_mode: formData.learningMode.toLowerCase(),
      source: 'website',
    };

    try {
      const response = await axios.post(`${Apiurl}/course-enquiries`, payload);
      console.log('✅ Submitted:', response.data);
      setSubmitMessage('Registration successful! We\'ll contact you soon.');
      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        interestedCourse: "",
        learningMode: "",
      });
      setErrors({});
    } catch (err) {
      console.error('❌ Error:', err);
      setSubmitError(err.response?.data?.message || 'Failed to register. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const [selectedCourse, setSelectedCourse] = useState('');

  // Function to handle enroll button click
  const handleEnrollClick = (course) => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  // Update formData when selectedCourse changes
  useEffect(() => {
    if (selectedCourse) {
      setFormData(prev => ({
        ...prev,
        interestedCourse: selectedCourse
      }));
    }
  }, [selectedCourse]);

  // Reset when modal closes
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedCourse('');
    setFormData({
      name: '',
      email: '',
      phoneNumber: '',
      interestedCourse: '',
      learningMode: ''
    });
    setErrors({});
    setSubmitMessage('');
    setSubmitError('');
  };

  const handleJoin = () => {
    navigate("/internship");
  };

  const ViewNowButton = ({ course }) => (
    <div className="d-flex justify-content-center mt-auto">
      <button
        className="btn btn-danger btn-sm px-4"
        onClick={() => navigate(`/course/FullStack`)}
      >
        View Now
      </button>
    </div>
  );

  return (
    <HelmetProvider>
      <div className="header" style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>
            {meta?.title ||
              "Courses - Aalan TechSoft | Software Development & Software Training in Salem"}
          </title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Explore our industry-focused courses in Full Stack Development, Web Design, App Development, and Software Training – designed to help you succeed."
            }
          />
        </Helmet>

        {/* Modal for Enroll Now */}
        <Modal show={showModal} onHide={handleModalClose} centered className="">
          <Modal.Header closeButton>
            <Modal.Title>Enroll Now</Modal.Title>
          </Modal.Header>
          <Modal.Body className="m-1">
            {submitMessage && <Alert variant="success">{submitMessage}</Alert>}
            {submitError && <Alert variant="danger">{submitError}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter your name"
                  isInvalid={!!errors.name}
                  className="rounded-1"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email ID *</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  isInvalid={!!errors.email}
                  className="rounded-1"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  placeholder="Enter your phone number"
                  isInvalid={!!errors.phoneNumber}
                  className="rounded-1"
                  pattern="[0-9]{10}"
                  maxLength={10}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.phoneNumber}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Interested Course</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.interestedCourse}
                  readOnly
                  className="rounded-1 bg-light"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Preferred Mode of Learning *</Form.Label>
                <Form.Select
                  name="learningMode"
                  value={formData.learningMode}
                  onChange={handleInputChange}
                  isInvalid={!!errors.learningMode}
                  required
                >
                  <option value="">Select a mode</option>
                  <option value="online">Online</option>
                  <option value="offline">Offline</option>
                  <option value="hybrid">Hybrid</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.learningMode}
                </Form.Control.Feedback>
              </Form.Group>
              <div className="text-center">
                <Button
                  variant="primary"
                  type="submit"
                  style={{
                    backgroundColor: "rgb(133, 191, 57)",
                    border: "none",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        {/* Hero Section */}
        <div className="Course-hero">
          <div className="about-content text-center">
            <div className="hero-title-container">
              <span className="badge-title">Course</span>
              <h1 className="text-white fw-bold">
                Bring your goals into focus
              </h1>
            </div>
          </div>
        </div>

        {/* Why Choose Course */}
        <section className="solutions-section container py-5">
          <div className="row align-items-center">
            {/* Left Side - Heading */}
            <div
              className="col-12 col-lg-6 col-md-12 mb-4 mb-md-0  text-center text-md-start"
              data-aos="fade-right"
              data-aos-delay="100"
             >
              <h2 className="section-title fw-bold display-5 mb-3">
                <span className="badge-title">Why Choose Us</span>
              </h2>
              <h2
                className="section-title"
                data-aos="fade-right"
                data-aos-delay="100"
              >
                Leading the Way: Best Institute for <br /> <span style={{ color: "#85bf39" }}>Full-Stack Developer
                Training in Salem</span>
              </h2>
            </div>

            {/* Right Side - Paragraph */}
            <div
              className="col-12 col-lg-6 col-md-12 pt-3 pt-md-5 text-center text-md-start"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <p className="section-text" style={{ textAlign: "justify" }}>
                As a leading institute in Salem, Aalan Tech Soft has a proven track
                record of producing successful full-stack developers. With over 20+
                comprehensive courses, we have helped 300+ students launch their
                careers in web development. Our dedicated placement guidance ensures
                that our graduates are well prepared for the job market, securing
                placements in top IT companies. Experience the Aalan Tech Soft
                difference and unlock your potential as a full-stack developer
                today!
              </p>
            </div>
          </div>
        </section>

        {/* Recommended Courses */}

        <div className="bg-light">

          <section className="container section-upcoming py-5 ">
            <div>
              <div className="text-center mb-5">
                <h1
                  className="section-title text-dark mb-3"
                  style={{ fontSize: "36px" }}
                >
                  Our <span style={{ color: "#85bf39" }}>Courses</span>
                </h1>
                <p className="section-text text-center">
                  Comprehensive courses, expert led training, and hands-on
                  projects for learners.
                </p>
              </div>

              <Row>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course1} alt="Python Full Stack Development" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">Python Full Stack Development</h5>
                      <p className="card-text">
                        Master Python, Django, React, and database technologies to design and develop robust, scalable full-stack applications.
                      </p>

                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a
                          href="/courses/python-full-stack"
                          className="btn btn-outline-primary p-2"
                        >
                          Course Syllabus
                        </a>

                        <button
                          onClick={() => handleEnrollClick("Python Full Stack Development")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course2} alt="Java Full Stack Development" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">Java Full Stack Development</h5>
                      <p className="card-text">
                        Learn Java, Spring Boot, Angular/React, and databases to develop robust enterprise applications.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/courses/java-full-stack" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("Java Full Stack Development")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course3} alt="MERN Stack Development" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">MERN Stack Development</h5>
                      <p className="card-text">
                        Build modern web apps using MongoDB, Express.js, React, and Node.js with hands on projects.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/courses/mern-stack" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("MERN Stack Development")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course4} alt="MEAN Stack Development" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">MEAN Stack Development</h5>
                      <p className="card-text">
                        Learn MongoDB, Express.js, Angular, and Node.js to develop scalable full-stack applications.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/courses/mean-stack" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("MEAN Stack Development")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course5} alt="Mobile App Development" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">Mobile App Development</h5>
                      <p className="card-text">
                        Design and develop Android & iOS applications using React Native and Flutter frameworks.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/courses/mobile-app-development" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("Mobile App Development")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course6} alt="Data Analysis" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">Data Analysis</h5>
                      <p className="card-text">
                        Gain expertise in Python, SQL, Excel, and visualization tools to analyze and interpret data effectively.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/courses/data-analysis" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("Data Analysis")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course7} alt="UI/UX Designing" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">UI/UX Designing</h5>
                      <p className="card-text">
                        Learn user centered design, wireframing, prototyping, and tools like Figma, Photoshop, and Illustrato.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/courses/ui-ux-design" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("UI/UX Designing")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course8} alt="AWS Cloud" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">AWS Cloud</h5>
                      <p className="card-text">
                        Learn the fundamentals of cloud computing and gain hands-on expertise with AWS services like EC2, S3, Lambda, and more.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/courses/aws-cloud" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("AWS Cloud")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <div className="card unity-course-card p-2" data-aos="fade-up"
                    data-aos-delay="100">
                    {/* Course Image */}
                    <img src={Course9} alt="DevOps Engineer" className="course-image" />

                    {/* Course Details */}
                    <div className="card-body">
                      <div className="d-flex justify-content-between gap-3 small text-dark mb-3">
                        {/* Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FaStar
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Advanced</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaLaptop
                            className="me-2"
                            style={{ width: "16px", height: "16px", color: "#85bf39" }}
                          />
                          <span>Online / Offline</span>
                        </div>
                      </div>

                      <h5 className="card-title">DevOps Engineer</h5>
                      <p className="card-text">
                        Learn CI/CD pipelines, Docker, Kubernetes, Git, Jenkins, and automation tools for DevOps practices.
                      </p>

                      {/* Action Buttons */}
                      <div className="course-actions d-flex justify-content-between gap-2 mt-3">
                        <a href="/DevOps" className="btn btn-outline-primary p-2 syllabus-btn">
                          Course Syllabus
                        </a>
                        <button
                          onClick={() => handleEnrollClick("DevOps Engineer")}
                          className="btn register-btn p-2"
                          style={{ backgroundColor: "#85bf39", color: "#fff", border: "none" }}
                        >
                          Enroll Now
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </section>


        </div>

        {/* Career Section */}
        <section className="career-section py-5">
          <Container>
            <Row className="align-items-center">
              {/* Left Column */}
              <Col
                lg={6}
                md={12}
                className="mb-4 mb-md-3"
                data-aos="fade-right"
                data-aos-delay="100"
              >
                <h2
                  className="career-title fw-bold"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  Launch Your Software <br />
                  Development Career with <br />
                  <span style={{ color: "#85bf39" }}>Aalan TechSoft</span>
                </h2>

                <Row className="mt-4">
                  <Col xs={6} data-aos="fade-up" data-aos-delay="100">
                    <ul className="career-list">
                      <li>
                        <FaStar className="icon" /> E-commerce website
                      </li>
                      <li>
                        <FaStar className="icon" /> Event management platform
                      </li>
                      <li>
                        <FaStar className="icon" /> Fitness tracking app
                      </li>
                      <li>
                        <FaStar className="icon" /> Weather forecasting application
                      </li>
                    </ul>
                  </Col>

                  <Col xs={6} data-aos="fade-up" data-aos-delay="100">
                    <ul className="career-list">
                      <li>
                        <FaStar className="icon" /> Task management application
                      </li>
                      <li>
                        <FaStar className="icon" /> Food delivery application
                      </li>
                      <li>
                        <FaStar className="icon" /> Music streaming service App
                      </li>
                      <li>
                        <FaStar className="icon" /> Job search website and more..
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Col>

              {/* Right Column */}
              <Col lg={6}
                md={12} data-aos="fade-left" data-aos-delay="100">
                <p className="section-text" style={{ textAlign: "justify" }}>
                  Aalan TechSoft equips students with the skills and knowledge
                  needed to thrive in the competitive world of software
                  development. Our full-stack developer course, which includes
                  hands on training with real time projects, prepares graduates
                  for a variety of exciting career paths. <br />
                  <br />
                  From web development and mobile app development to data
                  analysis and machine learning, our graduates have successfully
                  landed roles in top tech companies, startups, and government
                  organizations. With the strong foundation provided by Aalan
                  TechSoft, you'll be well-positioned to embark on a fulfilling
                  and rewarding career as a software developer. Examples of
                  software development projects you may work on include.
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Internship Section */}
        <section className="internship-section text-center py-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={10} lg={8}>
                {/* Heading */}
                <h2
                  className="fw-bold mb-4"
                  data-aos="fade-down"
                  data-aos-delay="100"
                >
                  ATS Offers Software Internships for <br /> College Students!
                </h2>

                {/* Subtitle */}
                <p
                  className="section-text mb-4 text-center"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  Join our software internship program today. Gain skills,
                  real-world experience, and a head start in your career.
                </p>

                {/* Button Center */}
                <div className="d-flex justify-content-center">
                  <Button
                    className="custom-btn shadow-sm"

                    onClick={() => {
                      navigate("/internship");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    data-aos="zoom-in"
                    data-aos-delay="100"
                    style={{ backgroundColor: "#85bf39" }}
                  >
                    <span
                      className="btn-text fw-semibold"
                      data-aos="fade-right"
                      data-aos-delay="100"
                    >
                      Join now
                    </span>
                    <span
                      className="btn-icon ms-2"
                      data-aos="fade-left"
                      data-aos-delay="100"
                    >
                      <FiArrowUpRight />
                    </span>
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* FAQ Section */}
        <section className="faq-section py-5 bg-light px-md-4">
          <div className="faq-container mx-auto px-3 px-sm-4">
            {/* Title */}
            <h2
              className="text-center fw-bold mb-4 section-title"
              data-aos="fade-down"
              data-aos-delay="100"
            >
              Got Questions? <span style={{ color: "#85bf39" }}>We've Got Answers!</span>
            </h2>

            {/* Subtitle */}
            <p
              className="text-center mb-5 section-text"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Uncover everything you need to know about our courses with our FAQ
              section.
            </p>

            {/* Accordion */}
            <Accordion defaultActiveKey="0" className="faq-accordion">
              <Accordion.Item eventKey="0" data-aos="fade-right" data-aos-delay="100">
                <Accordion.Header>
                  What technologies and programming languages will I learn in the course?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  Our full-stack developer course covers a wide range of technologies and programming languages. Not only does it include{" "}
                  <b>HTML, CSS, JavaScript, Node.js, React.js, MongoDB, Express.js, and SQL</b>, but it also introduces students to various development tools and frameworks used in the industry. Additionally, you'll gain hands on experience with these tools, enhancing your practical skills and preparing you for real-world projects.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" data-aos="fade-left" data-aos-delay="100">
                <Accordion.Header className="faq-title">
                  I'm from a non-engineering background or new to programming. Am I eligible for this course?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  Absolutely! Our full-stack developer course is suitable for individuals from diverse backgrounds, including non engineering and programming novices. Our comprehensive curriculum and supportive instructors will help you build a strong foundation in software development, regardless of your previous experience.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" data-aos="fade-right" data-aos-delay="100">
                <Accordion.Header>
                  Is the course offered offline or online?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  We offer both <b>offline and online</b> options for our full-stack developer course, providing flexibility to choose the format that best suits your schedule and learning preferences. Online courses feature live sessions, interactive exercises, and access to course materials from anywhere.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" data-aos="fade-left" data-aos-delay="100">
                <Accordion.Header>
                  Do I need any prior design experience to enroll in the UI/UX Designing course?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  No prior design experience is required. Our UI/UX design course is suitable for beginners and individuals with varying levels of design knowledge.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" data-aos="fade-right" data-aos-delay="100">
                <Accordion.Header>
                  Will the MEAN Stack course cover both front-end and back-end development?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  Yes, the course covers both <b>front-end and back-end</b> development aspects of the MEAN Stack. You'll learn how to build responsive and dynamic user interfaces with Angular on the front end, and develop robust server-side applications with Node.js and Express.js on the back end.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </section>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Courses;